import EmailIcon from '@mui/icons-material/Email';
import {Button} from '@mui/material';

export default function EmailHelpButton({
  size,
  color = 'inherit',
  href
}: {
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  href: string;
}) {
  return (
    <Button
      component="a"
      target="_blank"
      variant="outlined"
      color={color}
      startIcon={<EmailIcon />}
      fullWidth
      href={href}
      size={size}
    >
      Email
    </Button>
  );
}
